import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PageComponent } from './page.component';
import { MatriculacionComponent } from './matriculacion/matriculacion.component';
import { CambioPropiedadComponent } from './cambio-propiedad/cambio-propiedad.component';
import { JustificanteComponent } from './justificante/justificante.component';
import { ExpedientesComponent } from './expedientes/expedientes.component';
import { AuthGuard } from '../services/auth-guard.guard';
import { InformeComponent } from './informe/informe.component';
import { SolicitudesComponent } from './solicitudes/solicitudes.component';
import { ReduccionComponent } from './reduccion/reduccion.component';
import { MiCuentaComponent } from './mi-cuenta/mi-cuenta.component';
import { GestionUsersComponent } from './gestion/gestion-users/gestion-users.component';
import { DistintivoComponent } from './distintivo/distintivo.component';
import { UploadComponent } from '../components/upload/upload/upload.component';
import { BajaComponent } from './baja/baja.component';
import { DobleTransferenciaComponent } from './doble-transferencia/doble-transferencia.component';
import { ContactosComponent } from './contactos/contactos.component';
import { NosotrosComponent } from './nosotros/nosotros.component';
import { AyudasComponent } from './ayudas/ayudas.component';
import { FormSolicitudComponent } from '../components/form-solicitud/form-solicitud.component';
import { CompletarSolicitudComponent } from './completar-solicitud/completar-solicitud.component';
import { FirmaDocumentosComponent } from './firma-documentos/firma-documentos.component';

const routes: Routes = [
  { path: 'upload', pathMatch: 'full', component: UploadComponent },
  { path: 'completar', pathMatch: 'full', component: FormSolicitudComponent },

  {
    path: 'page',
    component: PageComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: {
          title: 'Inicio',
        },
      },
      {
        path: 'matriculacion',
        component: MatriculacionComponent,
        data: {
          title: 'Matriculación',
        },
      },
      {
        path: 'cambio',
        component: CambioPropiedadComponent,
        data: {
          title: 'Cambio de propiedad',
        },
      },
      {
        path: 'cambio/vendedor',
        component: CambioPropiedadComponent,
        data: {
          title: 'Cambio de propiedad',
        },
      },
      {
        path: 'cambio/comprador',
        component: CambioPropiedadComponent,
        data: {
          title: 'Cambio de propiedad',
        },
      },
      {
        path: 'cambio/intermediario',
        component: CambioPropiedadComponent,
        data: {
          title: 'Cambio de propiedad',
        },
      },
      {
        path: 'justificante',
        component: JustificanteComponent,
        data: {
          title: 'Justificante Profesional',
        },
      },
      {
        path: 'distintivo',
        component: DistintivoComponent,
        data: {
          title: 'Distintivo Medioambiental',
        },
      },
      {
        path: 'informe',
        component: InformeComponent,
        data: {
          title: 'informe',
        },
      },
      {
        path: 'reduccion',
        component: ReduccionComponent,
        data: {
          title: 'reduccion',
        },
      },
      {
        path: 'doble_transferencia',
        component: DobleTransferenciaComponent,
        data: {
          title: 'doble transferencia',
        },
      },
      {
        path: 'baja',
        component: BajaComponent,
        data: {
          title: 'baja',
        },
      },
      {
        path: 'expedientes',
        component: ExpedientesComponent,
        data: {
          title: 'Expedientes',
        },
      },
      {
        path: 'solicitudes',
        component: SolicitudesComponent,
        data: {
          title: 'Solicitudes',
        },
      },
      {
        path: 'cuenta',
        component: MiCuentaComponent,
        data: {
          title: 'Mi cuenta',
        },
      },
      {
        path: 'gestion',
        component: GestionUsersComponent,
        data: {
          title: 'Gestión de usuarios',
        },
      },
      {
        path: 'contactos',
        component: ContactosComponent,
        data: {
          title: 'Gestión de contactos',
        },
      },
      {
        path: 'nosotros',
        component: NosotrosComponent,
        data: {
          title: 'Directorio',
        }
      },
      {
        path: 'ayudas',
        component: AyudasComponent,
        data: {
          title: 'Gestión de ayudas',
        },
      },
      {
        path: 'completar2',
        component: CompletarSolicitudComponent,
        data: {
          title: 'Completar solicitud',
        },
      },
      {
        path: 'firma-documentos',
        component: FirmaDocumentosComponent,
        data: {
          title: 'Firma de Documentos',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageRoutingModule {}
